<template>
    <div :class="containerClasses" @click="$emit('click')">
        <img :src="booster.icon" :alt="title" class="mx-auto w-3/5">
        <div class="mt-10 text-center">
            <h2 :class="titleClasses">{{ title }}</h2>
            <price :item="booster" :class="priceClasses" />
            <div class="flex items-center mt-10 mb-10 justify-center">
                <div class="flex items-center space-x-6">
                    <span>{{ $t('boosters.share.media') }}:</span>
                    <template v-for="(active, icon) in booster.media">
                        <template v-if="active">
                            <img v-if="icon === 'instagram'"
                                 :class="mediaIconClasses"
                                 src="/app/img/instagram.svg"
                                 alt="instagram"
                            >
                            <svg-icon
                                v-else
                                :type="icon"
                                class="text-primary-80"
                                :class="mediaIconClasses"
                            />
                        </template>
                    </template>
                </div>
            </div>
            <p
                v-html="$t('boosters.share.duration', {days: booster.duration})"
                :class="durationClasses"></p>
            <simple-button
                v-if="withButton"
                display="secondary"
                look="primary"
                class="mx-auto mt-20"
            >
                {{ $t('jobs.sharing.request') }}
            </simple-button>
        </div>
    </div>
</template>
<script>
import Price from "../Price.vue";
import SvgIcon from "../ui/SvgIcon.vue";
import Booster from "../../models/Booster";
import SimpleButton from "../ui/SimpleButton.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";

export default {
    name: "BoosterCard",
    components: {
        SimpleButton,
        Price,
        SvgIcon
    },
    props: {
        booster: {
            type: Booster,
            required: true
        },
        mediaIconClasses: {
            type: String,
            default: 'w-24 h-24'
        },
        titleClasses: {
            type: String,
            default: 'font-semibold text-heading-1'
        },
        priceClasses: {
            type: String,
            default: 'mt-8 !text-body'
        },
        durationClasses: {
            type: String,
            default: 'text-body'
        },
        withButton: {
            type: Boolean,
            default: false
        },
        withHover: {
            type: Boolean,
            default: false
        },
        hoverClasses: {
            type: String,
            default: 'hover:border-2 transform hover:scale-110 transition group'
        },
        hide: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapStores(useMainStore),
        selectedLocale() {
            return this.mainStore.selectedLocale;
        },
        title() {
            return this.booster.title[this.selectedLocale];
        },
        containerClasses() {
            let classes;
            if (this.hide) {
                classes = 'pointer-events-none opacity-50 bg-primary-5';
            } else {
                if (this.withHover) {
                    classes = this.hoverClasses;
                }
            }
            return classes;
        }
    }
}
</script>
